function initBuyButton(buttonId, variantId) {
  function setup() {
    const btn = document.getElementById(buttonId);
    if (!btn) return;
    
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    
    newBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const body = JSON.stringify({ id: variantId, quantity: 1 });
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body
        });
        const data = await res.json();
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.getElementById('cart-drawer').show();
        
      } catch (err) {
        console.error('Add to cart failed', err);
        alert('Couldn\'t add to cart — please try again.');
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}